import { GenericService } from '@/services/api/generic.service';
import { EncounterRequestedAdviceMessage } from '@/custom/menicon/models';
import apiClient from '@/services/api/client/apiClient';
import { AxiosRequestConfig } from 'axios';

export class ExpertModeRequestMessagesService extends GenericService<EncounterRequestedAdviceMessage> {

  constructor(requestId?: string) {
    super(`menicon/v1/expert-mode/encounter-requested-advices/${requestId}/messages`);
  }

  async getUnreadCounts(config: AxiosRequestConfig = {}): Promise<{[key: string]: number}> {
    if (this.endpoint) {
      return (await apiClient.get(`${this.endpoint}/unread`, config)).data;
    }
    return {};
  }
}
